<ng-template [ngIfElse]="userServiceRef" [ngIf]="showSkeleton">
  <app-skeleton [stats]="'service'" [class.mobile]="deviceService.isMobile()"></app-skeleton>
</ng-template>

<ng-template #userServiceRef>
  <div
    *ngIf="userService"
    class="user-service-card-full"
    [class.modal]="modal"
    [class.tablet]="deviceService.isTablet()"
    [class.mobile]="deviceService.isMobile()"
    itemscope
    itemtype="https://schema.org/Article">
    <ng-container *ngTemplateOutlet="meta"></ng-container>

    <app-status-badge
      *ngIf="isUnderModerationOrDecline"
      [type]="'service'"
      [status]="userService.moderation_status"
      [reason]="userService.moderation_message">
    </app-status-badge>

    <app-user-service-meetings *ngIf="userService && !isAuthor" [user_service_id]="userService.id" [me]="me">
    </app-user-service-meetings>

    <div class="section main">
      <div class="tools">
        <app-bookmark [item]="userService" [type]="'service'"></app-bookmark>
        <on-ui-card-menu *ngIf="userService.purl || (debug$ | async)">
          <a class="menu-item warn" *ngIf="userService.purl" [href]="userService.purl">[⚠️] Panel</a>
          <div class="menu-item" *ngIf="debug$ | async" (click)="printDebugInfo()">DEBUG</div>
        </on-ui-card-menu>
      </div>

      <div class="header">
        <div class="cover-wrap">
          <on-ui-cover [cover]="cover"></on-ui-cover>
          <div class="type" [ngClass]="eUserServiceType[type]">{{ typeLabel(type) | customLocale }}</div>
        </div>
        <div class="info-block">
          <div [attr.title]="fullTitle" class="text-block">
            <div class="category" *ngIf="category">{{ 'user-service.category.' + category | customLocale }}</div>
            <p class="subject-wrap" [routerLink]="subjectRoute">
              <span class="subject">{{ subject }}</span>
              <ng-template [ngIf]="subjectIsNative">
                <span class="native">{{ 'library.user-service-card.native' | customLocale }}</span>
              </ng-template>
            </p>
            <p [routerLink]="userServiceRoute" class="title">{{ title | striptags }}</p>
          </div>

          <ng-container *ngTemplateOutlet="secondInfo"></ng-container>

          <div class="teacher-block">
            <ng-container *ngIf="userService.school_id; else teacherInfo">
              <div class="avatar-wrap school-avatar-wrap">
                <on-ui-cover [cover]="authorAvatar"></on-ui-cover>
              </div>
              <span class="teacher-name" itemprop="author">{{ authorAvatar?.title }}</span>
              <ng-container *ngTemplateOutlet="ratingWrap"></ng-container>
            </ng-container>
            <ng-template #teacherInfo>
              <app-author-info [user]="meetingAuthor"></app-author-info>
            </ng-template>
          </div>
        </div>
      </div>
      <div class="bottom-block">
        <div class="price-block">
          <div class="current-price">
            <span class="price">{{ getFormattedAmount() | async }}</span>
            <span class="period">{{ labelPeriod | customLocale }}</span>
          </div>
        </div>
        <div class="action-block">
          <ng-template
            [ngIf]="userService?.can?.signup"
            [ngIfThen]="availableActionsRef"
            [ngIfElse]="notAvailableActionsRef">
          </ng-template>
        </div>
      </div>
      <span inViewport (inViewportAction)="onInViewportChange($event)"></span>
    </div>

    <div class="additional-info">
      <div id="user-service-shade"></div>

      <div
        #navPosition
        class="tabs-wrap"
        [ngStyle]="{ top: topFromHeader + 'px' }"
        [class.stuck-shadow]="stuckState"
        [class.mobile]="deviceService.isMobile()">
        <ul class="tabs" itemscope itemtype="http://schema.org/SiteNavigationElement">
          <ng-template ngFor let-item [ngForOf]="mainTabs">
            <li [attr.title]="item.title | customLocale" class="categories-item">
              <a class="tab" [class.active]="activeTab === item.code" itemprop="url" (click)="navigate(item)">
                <span class="tab-name">{{ item.title | customLocale }}</span>
              </a>
            </li>
          </ng-template>
        </ul>
      </div>

      <ng-template [ngIf]="isActiveRoute('main')">
        <div *ngIf="skills?.length" class="section">
          <ng-container *ngTemplateOutlet="skillsTemplate"></ng-container>
        </div>
        <div *ngIf="requirements?.length" class="section">
          <ng-container *ngTemplateOutlet="requirementsTemplate"></ng-container>
        </div>
        <div *ngIf="!isSchool && isMediaPreparedMain" class="section">
          <ng-container *ngTemplateOutlet="video"></ng-container>
        </div>

        <div *ngIf="isSchool" class="section">
          <ng-container *ngTemplateOutlet="schoolVideo"></ng-container>
        </div>

        <div *ngIf="!!description" class="section">
          <h3 class="section-title">{{ 'user-service-card-full.titles.about' | customLocale }}</h3>
          <video *ngIf="safeMediaUrlMain" class="service-main-video" controls playsinline height="100%" width="100%">
            <source [src]="safeMediaUrlMain" type="video/mp4" />
          </video>
          <p class="description">{{ description | striptags }}</p>
        </div>

        <div *ngIf="latestMeetingReviews.items.length" class="section">
          <ng-container *ngTemplateOutlet="latestReviews"></ng-container>
        </div>

        <div *ngIf="!!otherUserServices?.length" class="section">
          <ng-container *ngTemplateOutlet="otherUserServicesTemplate"></ng-container>
        </div>

        <div *ngIf="!!meetingReviews?.items?.length" class="section">
          <ng-container *ngTemplateOutlet="reviews"></ng-container>
        </div>
      </ng-template>

      <div *ngIf="isActiveRoute('other') && !!otherUserServices?.length" class="section">
        <ng-container *ngTemplateOutlet="otherUserServicesTemplate"></ng-container>
      </div>

      <div *ngIf="isActiveRoute('about')" class="section no-padding">
        <app-user-profile-about-subpage [selectedSubjectId]="userService.subject_id" [profile]="authorProfile">
        </app-user-profile-about-subpage>
      </div>

      <div *ngIf="isActiveRoute('reviews') && !!meetingReviews?.items?.length" class="section">
        <ng-container *ngTemplateOutlet="reviews"></ng-container>
      </div>

      <div *ngIf="debug$ | async" class="section">
        <ng-container *ngTemplateOutlet="debugRef"></ng-container>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #meta>
  <meta itemprop="url" content="{{ userServiceRoute }}" />
  <meta itemprop="name" content="{{ fullTitle }}" />
  <meta itemprop="datePublished" content="{{ hlp_dateToISOString(contentDate) }}" />
  <meta itemprop="image" content="{{ metaImageUrl || coverImageUrl }}" />
  <meta *ngIf="description" itemprop="description" content="{{ description | striptags }}" />
  <meta itemprop="headline" content="" />
  <!-- keywords -->
  <meta itemprop="inLanguage" content="{{ userService.language?.code }}" />
</ng-template>

<ng-template #availableActionsRef>
  <on-ui-button
    *ngIf="userService?.can?.signup"
    class="secondary"
    [label]="isRegularClass() ? 'library.user-service-card.subscribe' : 'library.user-service-card.sign-up'"
    (click)="openCheckoutModal()">
  </on-ui-button>
</ng-template>

<ng-template #notAvailableActionsRef>
  <on-ui-button class="status" label="teacher-card.actions.no-available-hours"> </on-ui-button>
</ng-template>

<ng-template #ratingWrap>
  <app-rating [stats]="userService.school_id ? school : stats" [userId]="userService.author_id"> </app-rating>
</ng-template>

<ng-template #video>
  <ng-template [ngIf]="isMediaPreparedMain">
    <div class="video-block">
      <h3 class="section-title">{{ 'user-service-card-full.titles.school-video' | customLocale }}</h3>
      <iframe
        [src]="safeMediaUrlMain"
        frameborder="0"
        allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
        class="video">
      </iframe>
    </div>
  </ng-template>
</ng-template>

<ng-template #schoolVideo>
  <div class="school-video-wrap">
    <h3 class="section-title">{{ 'user-service-card-full.titles.school-video' | customLocale }}</h3>
    <div class="filter-block">
      <div class="filter-scroll">
        <ul class="filter-list">
          <li
            *ngFor="let tab of teachersTabs(); trackBy: trackByFn"
            class="filter-item"
            [class.selected]="isActiveVideo(tab)"
            (click)="onActiveVideo(tab)">
            <span class="filter-label">{{ videoTabLabel(tab) }}</span>
          </li>
        </ul>
      </div>
    </div>

    <ng-container *ngIf="isMediaPrepared; else videoPlaceholder">
      <ng-container *ngIf="isVideoFromYoutube; else recordedVideo">
        <iframe
          [src]="safeMediaUrl"
          allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
          class="school-video">
        </iframe>
      </ng-container>
      <ng-template #recordedVideo>
        <video class="school-video" controls playsinline height="100%" width="100%">
          <source [src]="safeMediaUrl" type="video/mp4" />
        </video>
      </ng-template>
    </ng-container>

    <ng-template #videoPlaceholder>
      <div class="school-video placeholder">
        <span class="video-placeholder">{{ 'user-service-form-3.video-placeholder' | customLocale }}</span>
      </div>
    </ng-template>
  </div>
</ng-template>

<ng-template #otherUserServicesTemplate>
  <div class="other-user-services">
    <h3 class="section-title">{{ 'user-service-card-full.titles.other-user-services' | customLocale }}</h3>
    <app-filter-content
      [tabs]="otherUserServicesTabs"
      [activeTab]="selectOtherUserServicesFilter"
      (onSelect)="onSelectOtherUserServicesFilter($event)">
    </app-filter-content>
    <div class="services-list">
      <div
        *ngFor="let otherService of filterUserServices(otherUserServices); trackBy: trackByFn"
        class="service-card-item">
        <app-user-service-card
          [service]="otherService"
          [displayMode]="'wide'"
          [authorDisplay]="false"
          (openUserServiceInModal)="onToggleUserServiceInModal($event)">
        </app-user-service-card>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #latestReviews>
  <div class="latest-reviews">
    <h3 class="section-title">{{ 'user-service-card-full.titles.latest-reviews' | customLocale }}</h3>
    <app-reviews-carousel [meetingReviews]="latestMeetingReviews.items"></app-reviews-carousel>
  </div>
</ng-template>

<ng-template #reviews>
  <div class="reviews">
    <h3 class="section-title">{{ 'user-service-card-full.titles.reviews' | customLocale }}</h3>

    <div class="review-cards">
      <div *ngFor="let review of meetingReviews.items; let i = index; trackBy: trackByFn" class="review-card-wrap">
        <app-meeting-review-form [meetingReview]="review"></app-meeting-review-form>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #secondInfo>
  <div class="second-info">
    <div class="row">
      <span class="text">
        {{ (isSingle ? 'library.user-service-card.one-on-one' : 'library.user-service-card.group') | customLocale }}
      </span>
      <div class="separator"></div>

      <ng-template [ngIf]="userService?.is?.ongoing" [ngIfThen]="ongoingService">
        [ngIfElse]="seriesService">
      </ng-template>
      <ng-template #ongoingService>
        <span class="text">
          {{ 'teacher-card.stats.classes' | customLocale }} {{ 'event-calendar.ongoing' | customLocale }}
        </span>
        <div class="separator"></div>
      </ng-template>
      <!--      <span class="text">{{ 'library.user-service-card.entry-level' | customLocale }}</span>-->
      <!--      <div class="separator"></div>-->
      <span class="text"
        >{{ 'user-service-form-3.fields.label9' | customLocale }} {{ age_from }}-{{ formatAge(age_to) }}</span
      >
    </div>
    <div class="row">
      <ng-template [ngIf]="weekdaysToString()">
        <span class="text">{{ weekdaysToString() }}</span>
        <div class="separator"></div>
      </ng-template>
      <span class="text">{{ duration }} {{ 'library.user-service-card.min' | customLocale }}</span>
      <div class="separator"></div>
      <span class="text">{{ 'constructor.form-language-label' | customLocale }}: {{ teachingLanguage }}</span>
    </div>
  </div>
</ng-template>

<ng-template #skillsTemplate>
  <div class="skills">
    <h3 class="section-title">{{ 'user-service-card-full.titles.skills' | customLocale }}</h3>
    <ul class="skills-list">
      <li *ngFor="let skill of skills; trackBy: trackByFn" class="skill-label">
        <div class="icon-wrap">
          <app-icon width="18" height="15" icon="daw"></app-icon>
        </div>
        {{ skill | striptags }}
      </li>
    </ul>
  </div>
</ng-template>

<ng-template #requirementsTemplate>
  <div class="requirements">
    <h3 class="section-title">{{ 'user-service-card-full.titles.requirements' | customLocale }}</h3>
    <ul class="requirements-list">
      <li *ngFor="let requirement of requirements; trackBy: trackByFn" class="requirements-label">
        <div class="icon-wrap">
          <app-icon width="18" height="15" icon="daw"></app-icon>
        </div>
        {{ requirement | striptags }}
      </li>
    </ul>
  </div>
</ng-template>

<app-modal
  *ngIf="deviceService.isDesktop() && userServiceCardFullInModal"
  [canClose]="false"
  (closed)="onToggleUserServiceInModal()">
  <app-modal-body>
    <app-user-service-card-full
      [userService]="openedUserService"
      [modal]="true"
      (inViewportChange)="onIinViewportChange($event)"
      (isCloseAllModals)="onToggleUserServiceInModal()">
    </app-user-service-card-full>
  </app-modal-body>
  <app-modal-ad>
    <ng-template [ngIf]="!surfaceBlockDisplay">
      <app-user-service-surface-block [userService]="openedUserService"></app-user-service-surface-block>
    </ng-template>
  </app-modal-ad>
</app-modal>

<app-mobile-modal
  *ngIf="!deviceService.isDesktop() && userServiceCardFullInModal"
  [titleVisible]="true"
  (closed)="onToggleUserServiceInModal()">
  <app-mobile-modal-body>
    <app-user-service-card-full [userService]="openedUserService" [modal]="true"></app-user-service-card-full>
  </app-mobile-modal-body>
</app-mobile-modal>

<ng-template #debugRef>
  <app-user-service-debug-schedule [userService]="userService"></app-user-service-debug-schedule>
  <app-user-service-debug-classrooms [userService]="userService"></app-user-service-debug-classrooms>
</ng-template>
